import React, { useCallback } from 'react';
import {
  Logo,
  PrivacyContent
} from '../../component/common/index'

function Privacy() {
  // const iconLink = window.location.search.split('iconLink=')[1] ? decodeURIComponent(window.location.search.split('iconLink=')[1]) : ''
  /* eslint-disable */
  // const history = new useHistory()
  const goHome = useCallback(() => {
    window.history.go(-1)
    // history.push(iconLink || '/')
  }, [])

  return (
    <div
      className='flex flex-col h-[100vh]'
    >
        <Logo pClassName='mb-[32px] px-3' onLogo={goHome}/>
        <div className=' px-3'>
          <div className='border-t border-lines h-0 mx-auto'/>
        </div>
        <div
          className='flex-1 overflow-y-scroll overflow-y-overlay px-3 '
          style={{ overflowAnchor: 'none' }}
        >
            <PrivacyContent />
        </div>
    </div>
  );
}

export default Privacy;
